import { Alert, Card, CardBody, Button } from 'reactstrap';
import { isApiError } from '../api/errors';

/**
 * Shared Loading-State für TanStack-Query-driven views.
 * Render-Slot in `app-main__inner` — full-width Skeleton-Look.
 */
export function QueryLoadingState({ label = 'Daten werden geladen…' }) {
  return (
    <Card>
      <CardBody className="text-center py-5">
        <div className="orbit-spinner mx-auto mb-3" aria-hidden />
        <p className="text-muted mb-0">{label}</p>
      </CardBody>
    </Card>
  );
}

/**
 * Shared Error-State. Branched auf `code` (siehe error-handling.md),
 * zeigt Operator-freundliche Message + Retry-Button.
 */
export function QueryErrorState({ error, onRetry }) {
  const code = isApiError(error) ? error.code : 'unknown_error';
  const msg = isApiError(error)
    ? error.message
    : 'Ein unerwarteter Fehler ist aufgetreten.';
  return (
    <Alert color="danger" className="mb-0">
      <h5 className="alert-heading">Daten konnten nicht geladen werden</h5>
      <p className="mb-2">{msg}</p>
      <p className="small text-muted mb-3">
        Error-Code: <code>{code}</code>
      </p>
      {onRetry && (
        <Button color="danger" outline size="sm" onClick={onRetry}>
          Erneut versuchen
        </Button>
      )}
    </Alert>
  );
}
